/**
 * Product add-ons (Gift Box / Gift Wrapping / Gift Bag)
 *
 * Intercepts the product form submit. If add-ons are checked, it first adds
 * the selected add-on variants to the cart via /cart/add.js, then re-submits
 * the form so the theme's own product-form logic runs unchanged (cart drawer /
 * notification rendering, error states, etc.).
 */
if (!customElements.get('product-addons')) {
  customElements.define(
    'product-addons',
    class ProductAddons extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;

        this.propertyInput = this.querySelector('input[name="properties[Add-ons]"]');
        this.onSubmitBound = this.onSubmit.bind(this);
        // Capture phase so we run before the theme's ProductForm submit handler.
        this.form.addEventListener('submit', this.onSubmitBound, { capture: true });
        this.addEventListener('change', this.syncProperty.bind(this));
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmitBound, { capture: true });
      }

      get selectedInputs() {
        return Array.from(this.querySelectorAll('input[data-addon-variant-id]:checked'));
      }

      /** Mirror the chosen add-ons onto the main line item as a property. */
      syncProperty() {
        if (!this.propertyInput) return;
        const titles = this.selectedInputs.map((input) => input.dataset.addonTitle);
        this.propertyInput.value = titles.join(', ');
        this.propertyInput.disabled = titles.length === 0;
      }

      onSubmit(event) {
        const items = this.selectedInputs.map((input) => ({
          id: Number(input.dataset.addonVariantId),
          quantity: 1,
        }));
        if (items.length === 0) return; // nothing selected: let the theme handle it

        event.preventDefault();
        event.stopImmediatePropagation();

        const config = fetchConfig('javascript');
        config.body = JSON.stringify({ items });

        fetch(`${routes.cart_add_url}`, config)
          .catch((error) => console.error('Add-on error:', error))
          .finally(() => {
            // Uncheck so the re-submit passes straight through to the theme
            // (and to prevent accidental double-adds on repeat clicks).
            this.selectedInputs.forEach((input) => (input.checked = false));
            this.form.requestSubmit();
            // The theme's handler reads FormData synchronously during requestSubmit,
            // so it's safe to clear the property afterwards for the next add.
            this.syncProperty();
          });
      }
    }
  );
}